import { classNames } from '../utilities';

export const DeleteIcon = ({ className, onClick }) => {
  return (
    <svg
      className={classNames(
        'Delete cursor-pointer',
        className ? className : ''
      )}
      onClick={onClick ? onClick : () => null}
      id="delete_icon"
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 2.66667H10.6667V0.666667C10.6667 0.489856 10.5964 0.320286 10.4714 0.195262C10.3464 0.0702379 10.1768 0 10 0H4.66667C4.48986 0 4.32029 0.0702379 4.19526 0.195262C4.07024 0.320286 4 0.489856 4 0.666667V2.66667H0.666667C0.489856 2.66667 0.320286 2.73691 0.195262 2.86193C0.0702379 2.98695 0 3.15652 0 3.33333C0 3.51014 0.0702379 3.67971 0.195262 3.80474C0.320286 3.92976 0.489856 4 0.666667 4H1.41133L2.672 14.0827C2.69215 14.2439 2.77046 14.3922 2.89224 14.4997C3.01402 14.6073 3.17087 14.6666 3.33333 14.6667H11.3333C11.4958 14.6666 11.6527 14.6073 11.7744 14.4997C11.8962 14.3922 11.9745 14.2439 11.9947 14.0827L13.2553 4H14C14.1768 4 14.3464 3.92976 14.4714 3.80474C14.5964 3.67971 14.6667 3.51014 14.6667 3.33333C14.6667 3.15652 14.5964 2.98695 14.4714 2.86193C14.3464 2.73691 14.1768 2.66667 14 2.66667ZM5.33333 1.33333H9.33333V2.66667H5.33333V1.33333ZM10.7447 13.3333H3.922L2.75533 4H11.9113L10.7447 13.3333Z"
        fill="#3D3D3D"
      />
    </svg>
  );
};
